import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function UserLockIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.1526 3.5154C12.633 3.34321 12.0774 3.25 11.5 3.25C8.6005 3.25 6.25 5.60051 6.25 8.5C6.25 10.7841 7.70857 12.7274 9.7451 13.4495C6.31022 14.2447 3.75 17.3234 3.75 21C3.75 21.4142 4.08579 21.75 4.5 21.75H18.5C18.9142 21.75 19.25 21.4142 19.25 21C19.25 17.3234 16.6898 14.2447 13.2549 13.4495C14.4922 13.0108 15.5161 12.1213 16.1293 10.9785C14.211 9.78258 12.9346 7.65373 12.9346 5.22675C12.9346 4.63555 13.0103 4.06204 13.1526 3.5154Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.821 4.375C16.0965 3.18203 17.1461 2.25 18.4999 2.25C19.5062 2.25 20.5762 2.54925 21.1617 3.64706C21.3566 4.01254 21.2183 4.46684 20.8528 4.66176C20.4874 4.85669 20.0331 4.71842 19.8381 4.35294C19.6236 3.95075 19.2345 3.75 18.4999 3.75C18.0191 3.75 17.6227 4.00324 17.4126 4.375H18.4999C18.9141 4.375 19.2499 4.71078 19.2499 5.125C19.2499 5.53921 18.9141 5.875 18.4999 5.875H17.2499V6.125H18.4999C18.9141 6.125 19.2499 6.46078 19.2499 6.875C19.2499 7.28921 18.9141 7.625 18.4999 7.625H17.4646C17.6845 7.98683 18.0563 8.24997 18.4999 8.24997C19.2345 8.24997 19.6236 8.04927 19.8381 7.64706C20.0331 7.28157 20.4874 7.14331 20.8528 7.33823C21.2183 7.53316 21.3566 7.98747 21.1617 8.35297C20.5762 9.45077 19.5062 9.74997 18.4999 9.74997C17.19 9.74997 16.1648 8.79181 15.8502 7.625H15.4999C15.0857 7.625 14.7499 7.28921 14.7499 6.875C14.7499 6.46078 15.0857 6.125 15.4999 6.125H15.7499V5.875H15.4999C15.0857 5.875 14.7499 5.53921 14.7499 5.125C14.7499 4.71078 15.0857 4.375 15.4999 4.375H15.821Z"
				fill="currentColor"
			/>
		</svg>
	);
}

UserLockIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default UserLockIcon;
